import script from "./MBotoesRodape.vue?vue&type=script&lang=ts&setup=true"
export * from "./MBotoesRodape.vue?vue&type=script&lang=ts&setup=true"

import "./MBotoesRodape.vue?vue&type=style&index=0&id=4a4d0d60&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4d0d60"]])

export default __exports__